  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this._initialized = false;
        }

        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;

          try {
            this.form = this.querySelector('form');
            if (!this.form) {
              console.warn('[product-form] No <form> found inside <product-form>. Add to Cart may not work.');
              return;
            }

            const variantInput = this.variantIdInput;
            if (variantInput) {
              variantInput.disabled = false;
            }

            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');

            if (this.submitButton) {
              this.submitButtonText = this.submitButton.querySelector('span');
              if (document.querySelector('cart-drawer')) {
                this.submitButton.setAttribute('aria-haspopup', 'dialog');
              }
            }

            this.hideErrors = this.dataset.hideErrors === 'true';
          } catch (e) {
            console.error('[product-form] Initialization error:', e);
          }
        }

        onSubmitHandler(evt) {
          evt.preventDefault();

          if (!this.submitButton) {
            this.submitButton = this.querySelector('[type="submit"]');
            if (this.submitButton) this.submitButtonText = this.submitButton.querySelector('span');
          }

          if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          if (this.submitButton) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
          }
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          let config;
          try {
            config = fetchConfig('javascript');
          } catch (e) {
            config = { method: 'POST', headers: { Accept: 'application/javascript' } };
          }
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          const variantInput = this.form.querySelector('[name=id]');
          console.log('%c[product-form] === ADD TO CART SUBMIT ===', 'background: #222; color: #ff0; font-weight: bold; padding: 4px 8px;');
          console.log('[product-form] Variant ID being sent:', formData.get('id'));
          if (variantInput) {
            console.log('[product-form] Product ID (from data attr):', variantInput.dataset.productId || 'N/A');
            console.log('[product-form] Product handle:', variantInput.dataset.productHandle || 'N/A');
            console.log('[product-form] Variant title:', variantInput.dataset.variantTitle || 'N/A');
          }

          if (!this.cart) {
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          }

          if (this.cart) {
            try {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            } catch (e) {
              console.warn('[product-form] Cart sections error:', e);
            }
          }
          config.body = formData;

          const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

          fetch(cartAddUrl, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                console.error('[product-form] ❌ Shopify REJECTED add-to-cart:', response.description || response.message);
                console.error('[product-form] Variant ID that was rejected:', formData.get('id'));
                console.error('[product-form] This means the variant has 0 inventory in Shopify Admin.');
                console.error('[product-form] FIX: Shopify Admin → Products → Variants → Check "Continue selling when out of stock"');
                
                try {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                } catch (e) { /* pub/sub not critical */ }

                this.handleErrorMessage(response.description);
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
                return;
              }

              try {
                if (typeof CartPerformance !== 'undefined') {
                  var startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                }
              } catch (e) { /* performance tracking not critical */ }

              if (!this.error) {
                try {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  }).then(() => {
                    try {
                      if (typeof CartPerformance !== 'undefined' && startMarker) {
                        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                      }
                    } catch (e) { /* not critical */ }
                  });
                } catch (e) {
                  console.warn('[product-form] PubSub error:', e);
                }
              }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      try {
                        if (typeof CartPerformance !== 'undefined') {
                          CartPerformance.measure("add:paint-updated-sections", () => {
                            this.cart.renderContents(response);
                          });
                        } else {
                          this.cart.renderContents(response);
                        }
                      } catch (e) {
                        this.cart.renderContents(response);
                      }
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                try {
                  if (typeof CartPerformance !== 'undefined') {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  } else {
                    this.cart.renderContents(response);
                  }
                } catch (e) {
                  this.cart.renderContents(response);
                }
              }
            })
            .catch((e) => {
              console.error('[product-form] Add to cart fetch error:', e);
            })
            .finally(() => {
              if (this.submitButton) {
                this.submitButton.classList.remove('loading');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              }
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              const spinnerEl = this.querySelector('.loading__spinner');
              if (spinnerEl) spinnerEl.classList.add('hidden');

              try {
                if (typeof CartPerformance !== 'undefined') {
                  CartPerformance.measureFromEvent("add:user-action", evt);
                }
              } catch (e) { /* not critical */ }
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable = true, text) {
          if (!this.submitButton) return;
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text && this.submitButtonText) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        get variantIdInput() {
          return this.form ? this.form.querySelector('[name=id]') : null;
        }
      }
    );
  }
